export default "__VITE_ASSET__Be0cn9uM__"